import React, { useState, useEffect } from 'react';
import { Typography, Row, Col, Card, Input, Spin, Alert } from 'antd';
import { getEvents } from '../services/eventsService';

const { Search } = Input;

function EventCard({ event }) {
  const formatDate = dateString => {
    const date = new Date(dateString);
    const timeStr = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
    });
    const dateStr = date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
    return `${dateStr} at ${timeStr}`;
  };

  return (
    <Card
      cover={
        <div style={{ position: 'relative' }}>
          <img
            alt={event.name}
            src={event.image_url || 'https://source.unsplash.com/random?event'}
            style={{ height: 200, width: '100%', objectFit: 'cover' }}
          />
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
              padding: '20px',
              color: 'white',
            }}
          >
            <Typography.Title level={5} style={{ color: 'white', margin: 0 }}>
              {event.name}
            </Typography.Title>
            <Typography.Text style={{ color: 'white' }}>
              {formatDate(event.start_date)}
            </Typography.Text>
          </div>
        </div>
      }
      bodyStyle={{ display: 'none' }}
      style={{
        height: '200px',
        cursor: 'pointer',
      }}
      onClick={() => window.open(event.ticket_url, '_blank')}
    />
  );
}

function EventsEmbed() {
  const [events, setEvents] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const data = await getEvents();
        setEvents(data);
        setFilteredEvents(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  const handleSearch = value => {
    const filtered = events.filter(
      event =>
        event.name.toLowerCase().includes(value.toLowerCase()) ||
        event.description?.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredEvents(filtered);
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '24px' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '24px' }}>
        <Alert message={error} type="error" />
      </div>
    );
  }

  return (
    <div style={{ padding: '24px' }}>
      <Search
        placeholder="Search events..."
        onChange={e => handleSearch(e.target.value)}
        style={{ marginBottom: 24 }}
      />

      <Row gutter={[16, 16]}>
        {filteredEvents.map(event => (
          <Col key={event.id} xs={24} sm={12} md={8} lg={6}>
            <EventCard event={event} />
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default EventsEmbed;
